<template>
    <div class="register-container">
        <el-form ref="RegisterForm" class="login-form" hide-required-asterisk status-icon aria-autocomplete="no" :model="RegisterForm" :rules="RegisterRules" label-width="1rem">
            <div class="title-container">
                <h4>注册</h4>
            </div>
            <el-form-item prop="name" label="姓名">
                <el-input name="name" type="text" v-model="RegisterForm.name" autoComplete="on" placeholder="请输入真实姓名"></el-input>
            </el-form-item>
            <!-- <el-form-item prop="idcard" label="身份证号">
                <el-input name="idcard" type="type" v-model="RegisterForm.idcard" autoComplete="on" placeholder="请输入身份证号"></el-input>
            </el-form-item> -->
            <el-form-item prop="username" label="账号">
                <el-input name="username" type="text" v-model="RegisterForm.username" autoComplete="on" placeholder="请设置账号"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
                <el-input name="password" type="password" v-model="RegisterForm.password" autoComplete="on" placeholder="请设置密码"></el-input>
            </el-form-item>
            <el-form-item prop="again" label="确认密码">
                <el-input name="again" type="password" v-model="RegisterForm.again" autoComplete="on" placeholder="请确认密码"></el-input>
            </el-form-item>
          <el-form-item prop="codeRandom" label="验证码">
            <el-input style="width: 50%;" type="text" v-model="RegisterForm.codeRandom" autoComplete="on" placeholder="请输入验证码"></el-input>
            <img :src="imgUrl" alt="" @click="getRandom()" style="width: 0.95rem;height: 0.25rem;cursor: pointer;display: inline-block;background: #ccc;">
          </el-form-item>
            <!-- <el-form-item prop="email" label="电子邮箱">
                <el-input name="email" type="text" v-model="RegisterForm.email" autoComplete="on" placeholder="请输入电子邮箱"></el-input>
            </el-form-item> -->
            <!-- <el-form-item prop="mechanism" label="请选择机构">
                <el-select v-model="RegisterForm.mechanism" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="(item, index) of mList" :key="index" :label="item" :value="index"></el-option>
                </el-select>
            </el-form-item> -->
<!--            <el-form-item prop="iphone" label="手机号">
                <el-input name="iphone" type="text" v-model="RegisterForm.iphone" autoComplete="on" placeholder="请输入手机号"></el-input>
            </el-form-item>-->
<!--          <el-form-item prop="VEmail" label="电子邮箱">-->
<!--            <el-input name="VEmail" type="text" v-model="RegisterForm.VEmail" autoComplete="on" placeholder="请输入电子邮箱"></el-input>-->
<!--          </el-form-item>-->
            <!-- <el-form-item prop="code" label="验证码" class="changeError"> -->
                <!-- <span class="code" @click="changeCode()">{{this.code}}</span> -->
                <!-- <el-input v-model="RegisterForm.code" autoComplete="on" placeholder="验证码，区分大小写" style="width: 79%;"></el-input> -->
<!--            <el-form-item prop="code" label="验证码">
                <el-input v-model="RegisterForm.code" autoComplete="on" placeholder="验证码，区分大小写">
                    <el-button slot="append" type="primary" @click="changeCode()" :disabled="disabled">{{codetips}}</el-button>
                </el-input>
            </el-form-item>-->
            <!-- <p class="check">用户协议 <el-checkbox v-model="checked">教育服务系统用户注册协议</el-checkbox></p> -->


<!--            <div class="check">
                <p style="margin-right: .1rem;">用户协议</p>
                <el-checkbox v-model="checked" disabled></el-checkbox>
                <p style="margin-left: .1rem;cursor: pointer;" @click="dialogAgreementVisible = true">用户注册协议</p>
            </div>-->
            <!-- 协议提示框 -->
            <el-dialog :title="agreementData.VTitle" :visible.sync="dialogAgreementVisible">
                <!-- 标题 -->
                <p class="argummentTitle">{{agreementData.VTitle}}</p>
                <div class="argumentCon" v-html="agreementData.TContent"></div>
                <div style="display: flex;align-items: center;line-height:2">
                    <p style="margin-right: .1rem;">是否同意对平台免费开放非商业用途？</p>
                    <el-radio-group v-model="whether" >
                        <el-radio :label="0">同意</el-radio>
                        <el-radio :label="1">不同意</el-radio>
                    </el-radio-group>
                </div>
                <div style="display:flex;line-height:2">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <p style="margin-left: .1rem;cursor: pointer;" @click="dialogAgreementVisible = true">我已仔细阅读并同意以上协议</p>
                </div>
                <!-- 确定按钮 -->
                <div class="okBtn">
                    <el-button @click="onOk()" type="primary" style="margin: 0 auto;">确定</el-button>
                </div>
            </el-dialog>
            <div class="outerDiv">
                <el-button type="primary" @click="submitForm('RegisterForm')">确认</el-button>
                <el-button @click="back()">返回</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import { createCode, ValidateName, ValidateIdCard, ValidateEmail } from '../../untils/auth'
import Qs from 'qs'
import CryptoJS from "@/untils/CryptoJS";

export default {
    name: 'Register',
    data() {
        const validateName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('姓名不能为空'))
            } else if (!ValidateName(value)) {
                callback(new Error('姓名格式不正确'))
            } else {
                callback()
            }
        }
        const validateIdCard =(rule, value, callback) => {
            if (!value) {
                callback(new Error('身份证号不能为空'))
            } else if (!ValidateIdCard(value)) {
                callback(new Error('身份证格式不正确'))
            } else {
                callback()
            }
        }
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error('用户名不能为空'))
            } else if (value.length < 1) {
                callback(new Error('用户名不能少于1位'));
            } else {
                callback()
            }
        }
        const validatePassword = (rule, value, callback) => {
          if (!value) {
            callback(new Error('密码不能为空'))
          } if (!/^(?=.*[a-zA-Z])(?=.*\d).{6,}$/.test(value)) {
            callback(new Error("请输入有大写或者小写字母 包含数字 并且不小于6位"));
          } else {
            callback();
          }
        }
        const validateAgain = (rlue, value, callback) => {
            if (!value) {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.RegisterForm.password) {
                callback(new Error('两次输入密码不一致'))
            } else {
                callback()
            }
        }
       /* const validateEmail = (rule, value, callback) => {
            if (!value) {
                callback(new Error('电子邮箱不能为空'))
            } else if (!ValidateEmail(value)) {
                callback(new Error('电子邮箱格式不正确'))
            } else {
                callback()
            }
        }*/
      /*  const validateIphone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('手机号不能为空'))
            } else if (!ValidateIphone(value)) {
                callback(new Error('手机号格式不正确'))
            } else {
                callback()
            }
        }*/
       /* const validateCode = (rlue, value, callback) => {
            if (!value) {
                callback(new Error('请输入验证码'))
            }
            // else if (value !== this.code) {
            //     callback(new Error('输入验证码错误'))
            // }
            else {
                callback()
            }
        }*/
        const validateChecked = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请勾选协议'))
            } else {
                callback()
            }
        }
        return {
            codetips: '获取验证码',
            checked: true,
            code: '',
            imgUrl: '',
            disabled: false,
            RegisterForm: {
                name: '',
                // idcard: '',
                username: '',
                password: '',
                again: '',
                // VEmail: '',
                // mechanism: '',
                iphone: '',
                codeRandom: ''
                // code: ''
            },
            mList: ['机构1', '机构2', '机构3', '机构4'],
            RegisterRules: {
                name: [{ required: true, trigger: 'blur', validator: validateName }],
                // idcard: [{ required: true, trigger: 'blur', validator: validateIdCard }],
                username: [{ required: true, trigger: 'blur', validator: validateUsername }],
                password: [{ required: true, trigger: 'blur', validator: validatePassword }],
                again: [{ required: true, trigger: 'blur', validator: validateAgain }],
                codeRandom: [{ required: true, message: '请输入验证码', trigger: 'blur' },]
                // VEmail: [{ required: true, trigger: 'blur', validator: validateEmail }],
                // mechanism: [{ required: true, message: '请选择机构', trigger: 'change' }],
                // iphone: [{ required: true, trigger: 'blur', validator: validateIphone }],
                // code: [{ required: true, trigger: 'blur', validator: validateCode }],
            },
            // 协议内容
            argContent: '内容',
            // 弹框中是否阅读协议选项
            readAgreement: false,
            // 协议提示框
            dialogAgreementVisible: false,
            // 是否同意非商业用途
            whether: 0,
            // 协议
            agreementData: {}
        }
    },
    created() {
        // this.changeCode()
      this.getRandom()
        // 协议内容
        this.onAgreementInfo();
    },
    methods: {
        // 协议内容
        onAgreementInfo (){
            this.axios.post(window.IPConfig.IP + '/tBusServiceAgreement/getById.do?Id=c9f89858d926ff72f5cfc9c30128a3ce').then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 200) {
                        // 内容赋值
                        this.agreementData = response.data.obj;
                    }
                }
            })
        },
    /*    changeCode () {
            // this.RegisterForm.code = createCode();
            // 判断手机号是否输入
            if(this.RegisterForm.VEmail){
                // 请求验证码（邮箱）
                this.axios.get(window.IPConfig.IP + '/LoginController/getEmailCode.do?VEmail=' + this.RegisterForm.VEmail).then((response) => {
                    if (response.status == 200) {
                          // 倒计时
                          this.disabled = true;
                          this.codetips = '60秒后获取';
                          var self = this;
                          var codeNum = 60;
                          var timer = setInterval(function () {
                              codeNum--;
                              if (codeNum == 0) {
                                  clearInterval(timer);
                                  self.codetips = '获取验证码';
                                  self.disabled = false;
                              } else {
                              self.codetips = codeNum + '秒后获取'
                              }
                          }, 1000)
                    }
                })
            }
        },*/

      getRandom() {
        this.imgUrl = window.IPConfig.IP + '/CodeRandomController/getRegisterVerify.do?' + Math.random()
      },

        submitForm (formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // let userInfo = {
                    //     "tbUser": {
                    //         "VLoginname": this.RegisterForm.name,
                    //         "VNickname": this.RegisterForm.username,
                    //         "VPassword": this.RegisterForm.password,
                    //         "VPhoneNumber": this.RegisterForm.iphone,
                    //         "VSystemId": this.$store.state.user.VSystemId
                    //     },
                    //     "code": this.RegisterForm.code
                    // }
                    // this.axios({
                    //     method: 'post',
                    //     url: window.IPConfig.IP + '/LoginController/register.do',
                    //     data: Qs.stringify(userInfo)
                    // })
                    if(this.checked){
                        // 注册提交
                        this.axios.post(window.IPConfig.IP + '/LoginController/register.do',
                        {
                            "VNickname": this.RegisterForm.name,
                            "VLoginname": this.RegisterForm.username,
                            "code": this.RegisterForm.codeRandom,
                            "VPassword": CryptoJS.encrypt(this.RegisterForm.password),
                            "VSystemId": this.$store.state.user.VSystemId,

                        })
                        .then((response) => {
                          console.log(response)
                          if (response.status == 200) {
                              if (response.data.status == 200) {
                                // this.RegisterForm.password = CryptoJS.decrypt(this.RegisterForm.password)
                                this.$message.error('注册成功');
                                // 跳转登录页面
                                this.$router.push('/login')
                              } else {
                                this.$message.error(response.data.msg);
                              }
                          }else{
                            this.$message.error(response.data.msg);
                          }
                        },function(res){
                          this.$message.error('请求失败处理');
                        })
                    }else{
                        this.$message.error('请勾选协议');
                    }
                } else {
                    return false;
                }
            });
        },
        back () {
            window.history.back(-1);
        },
        // 协议确定
        onOk (){
            // 判断是否同意协议,如果同意，修改外部状态，隐藏协议
            // 是否同意非商业用途 this.whether = 0
            //this.readAgreement
            if(this.checked){
                // 协议提示框
                this.dialogAgreementVisible = false;
            }else{
                this.$message.error('请同意协议');
            }
        }
    }
}
</script>

<style>
    .register-container {
        width: 6rem;
        background: #fff;
        padding: 0 0.4rem 0.4rem
    }
    .register-container .title-container {
        font-size: 0.18rem;
        margin: 0.4rem auto 0.2rem;
    }
    .register-container .outerDiv {
        padding-top: 0.1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: flex-end;
    }
    .register-container .code {
        display: inline-block;
        width: 20%;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        font-size: 0.2rem;
        font-weight: bolder;
        border: 1px solid #DCDFE6;
        vertical-align: middle;
        border-radius: 0.05rem;
        cursor: pointer;
    }
    .register-container .changeError .el-form-item__error {
        left: 21%;
    }
    .register-container .check {
        /* display: inline-block; */
        display: flex;
        align-items: center;
        width: 3.15rem;
        text-align: center;
        padding-left: .3rem;
        line-height: 2;
    }
    /* 弹出框协议内容 */
    .argummentTitle{
        width: 100%;
        text-align: center;
        font-size: .3rem;
        font-weight: 700;
    }
    .okBtn{
        position: absolute;
        bottom: .1rem;
        right: .5rem;
    }
    .argumentCon{
        text-indent: 2em;
        line-height: 2;
        height: 4rem;
        overflow-y: scroll;
    }
</style>



// WEBPACK FOOTER //
// src/components/Login/register.vue